import type { RiskRule } from '../models/types';

export function filterRiskRules(rules: RiskRule[], search: string): RiskRule[] {
  const query = search.trim().toLowerCase();
  if (!query) return rules;

  return rules.filter((rule) => {
    const haystack = `${rule.label} ${rule.ruleType}`.toLowerCase();
    return haystack.includes(query);
  });
}
